export default __webpack_public_path__ + "static/media/main-portrait.e0692215.jpg";